import { render } from "./matching-card-compact-placeholder.vue?vue&type=template&id=59d785bd&scoped=true&ts=true"
import script from "./matching-card-compact-placeholder.vue?vue&type=script&lang=ts"
export * from "./matching-card-compact-placeholder.vue?vue&type=script&lang=ts"

import "./matching-card-compact-placeholder.vue?vue&type=style&index=0&id=59d785bd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d785bd"]])

export default __exports__